import React from 'react';

import './index.scss';
import { Icon, Popup, Portal} from 'semantic-ui-react';
import { ClippedContent } from '../ClippedContent';
import { Link } from 'react-router-dom';
import { PhoneUtil } from 'utils';
import { DragOverlay, useDraggable } from '@dnd-kit/core';
import DragHandle from '../DragHandle';
import DraggableCall from 'dyl-components/molecules/DraggableCall';
import phoneUtils from "utils/PhoneUtil";

const OfficeViewDestinationActiveCall = ({ call, transfer, type, source = null, userPhoneCreds, onListen }) => {
    const isTeams = type === 'teams';
    const notTrasferable = type === 'conference_room' || isTeams;
    
    const leg = call.legs?.find(leg => leg.name === call.name);
    const displayName = call?.company_destination?.substr(0, 1) === '7' && isTeams ?
        call.name
        :
        leg?.contact_id || leg?.account_id ?
            <Link target="_blank" to={`/${leg?.contact_id ? 'contact' : 'account'}/${leg?.contact_id || leg?.account_id}`}>
                {call.name}
            </Link>
            :
            leg?.user_id ?
                <Link target="_blank" to={`/settings/users/${leg.user_id}/general`}>
                    {call.name}
                </Link>
                :
                call.name;

    const isDragDisabled = notTrasferable || !source;
    const contactLeg = phoneUtils.contactLeg(call, userPhoneCreds);
    const { isDragging, setNodeRef, attributes, listeners, setActivatorNodeRef } = useDraggable({
        id: call.uuid,
        disabled: isDragDisabled,
        data: {
            source,
            channel_uuid: contactLeg?.channel_uuid,
            phone: contactLeg?.phone,
            pbx: call.pbx,
            caller_id_name: call.name,
            call
        }
    });
    const dragHandle = <DragHandle ref={setActivatorNodeRef} disabled={isDragDisabled} isDragging={isDragging} {...listeners} {...attributes} />;
    const durationDisplay = PhoneUtil.timeTicker(call.duration);
    return (
        <>
            <div ref={setNodeRef}>
                {!isDragging && (
                    <div className={`CompanyDestination__callContainer${call.actionButtons?.hold ? '--hold' : call.connected > 0 ? '--active' : '--ringing'}`} data-uuid={call.uuid}>
                        <div className='CompanyDestination__callLeft'>
                            {dragHandle}
                            <Icon size={"large"} className='fa-solid fa-phone-plus' style={{marginRight: 7}} />
                            <div>
                                <ClippedContent>
                                    {displayName}           
                                </ClippedContent>
                            </div>
                        </div>
                        <div className={'CompanyDestination__callRight '}>
                            <Popup 
                                trigger={<Icon disabled={!onListen || !(call.connected > 0)} onClick={onListen} size={"large"} className='fa-solid fa-ear-listen CompanyDestination__callArrows' />}
                                position='top center'
                                inverted
                                content='Listen'
                            />
                            <Icon disabled={notTrasferable} size={"large"} className='fa-solid fa-arrow-right-arrow-left CompanyDestination__callArrows' onClick={() => {transfer(call)}} />
                            {call.duration >= 0 && <span style={{marginRight: 7}}>{durationDisplay}</span>}
                        </div>
                    </div>
                )}
            </div>
            <Portal open={isDragging}>
                <DragOverlay>
                    <DraggableCall 
                        dragHandle={dragHandle}
                        duration={call.duration >= 0 && durationDisplay}
                        personDisplay={displayName}
                        isHeld={call.actionButtons?.hold}
                    />
                </DragOverlay>
            </Portal>
        </>
    )
}

export default OfficeViewDestinationActiveCall;
